import moment from "moment";

function ProofOfPlayMultiDisplayCtrl(
  $scope,
  $state,
  $stateParams,
  sweet,
  DateManipulationService,
  ProofPlayService,
  ProofOfPlayReportsV2Service,
  ToastsService
) {
  "ngInject";

  let vm = this;

  vm.radioButtonChoices = {
    group1: 'By Date',
    group2: 'Summarized',
    selection: null
  };

  vm.dateTimeSelection = {
    start: null,
    end: null
  };

  vm.formValidity = {
    start_date: false,
    end_date: false,
    displays: false,
  };

  vm.tenant = $stateParams.tenantId;
  vm.loading = true;
  vm.disabled = true;
  vm.disabledTenant = true;
  vm.selected_displays = [];
  vm.currentTenant = vm.tenant;

  vm.initialize = () => {
    ProofPlayService.getAllDisplays(vm.tenant)
      .then(function (data) {
        vm.loading = false;
        vm.displays = data.data.devices;
        if (vm.displays.length > 0) {
          return vm.had_some_items = true;
        } else {
          return vm.had_some_items = false;
        }
      })
  };

  vm.refreshDisplays = function () {
    vm.searchText = '';
    vm.selectedItem = '';
    vm.loading = true;
    vm.disabled = true;
    vm.selected_displays = [];
    vm.initialize();
  };

  vm.addToSelectedDisplays = function (searchText) {
    if (vm.isDisplayValid(searchText)) {
      vm.selected_displays.push(searchText);
      let index = vm.displays.indexOf(searchText);
      vm.displays.splice(index, 1);
      vm.searchText = '';
    }
    vm.areDisplaysValid();
    return vm.isDisabled();
  };

  vm.isRadioValid = function (selection) {
    vm.formValidity.type = selection;
    return vm.isDisabled();
  };


  vm.isDisplayValid = function (searchText) {
    if (__in__(searchText, vm.displays)) {
      if (!__in__(searchText, vm.selected_displays)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  vm.areDisplaysValid = function () {
    vm.formValidity.displays = (vm.selected_displays.length > 0);
    return vm.isDisabled();
  };

  vm.isStartDateValid = function (start_date) {
    vm.formValidity.start_date = (start_date instanceof Date);
    return vm.isDisabled();
  };


  vm.isEndDateValid = function (end_date) {
    vm.formValidity.end_date = (end_date instanceof Date);
    return vm.isDisabled();
  };

  vm.removeFromSelectedDisplay = function (item) {
    let index = vm.selected_displays.indexOf(item);
    vm.selected_displays.splice(index, 1);
    vm.displays.push(item);
    vm.areDisplaysValid();
    return vm.isDisabled();
  };


  vm.isDisabled = function () {
    if (vm.formValidity.start_date && vm.formValidity.end_date && vm.formValidity.displays && vm.formValidity.type) {
      vm.disabled = false;
      return vm.final = {
        start_date: DateManipulationService.isoDate(vm.dateTimeSelection.start),
        end_date: DateManipulationService.isoDate(vm.dateTimeSelection.end),
        displays: vm.selected_displays,
        type: vm.radioButtonChoices.selection

      };

    } else {
      return vm.disabled = true;
    }
  };

  vm.submit = function () {
    let reportType = {
      '1': 'MULTI_DEVICE_BY_DATE',
      '2': 'MULTI_DEVICE_SUMMARIZED',
    }[vm.final.type];
    let data = {
      'tenantId': vm.tenant,  // this is actually tenantId
      'type': reportType,
      'startDate': vm.final.start_date,
      'endDate': vm.final.end_date,
      'parameters': {
        'customerDisplayCodes': vm.final.displays,
      }
    };
    return ProofOfPlayReportsV2Service.post(data)
      .then(() => {
        return $scope.changeToReportList();
        //return $state.go('tenantProofPlay',
          //{tenantId: $stateParams.tenantId});  // explicitly passing because the routes aren't siblings (they aren't acually nested)
      }, () => {
        return sweet.show('Oops...', 'There was a problem queueing the report.', 'error');
      });
  };

  vm.querySearch = (resources, searchText) => ProofPlayService.querySearch(resources, searchText);

  return vm;
};

function __in__(needle, haystack) {
  return haystack.indexOf(needle) >= 0;
}

export {ProofOfPlayMultiDisplayCtrl}
